// Caminho do arquivo: src/components/common/CategoryFilter.tsx

interface CategoryFilterProps {
    label: string;
    icon?: string;
    isActive?: boolean;
    onClick: () => void;
}

export function CategoryFilter({ label, icon, isActive = false, onClick }: CategoryFilterProps) {
    const baseClasses = "flex items-center gap-2 px-4 py-3 rounded-xl font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap";
    const activeClasses = "bg-brand-blue text-white shadow-subtle";
    const inactiveClasses = "bg-card-bg text-text-secondary hover:bg-gray-100";

    return (
        <button onClick={onClick} className={`${baseClasses} ${isActive ? activeClasses : inactiveClasses}`}>
            {icon && <span className="text-xl">{icon}</span>}
            <span>{label}</span>
        </button>
    );
}